<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
      v-col.py-0.text-right
        v-btn(color="white", @click="save()", :disabled="loading || reportUnit.jrxml.jrxmlFile.content == null") {{ $t('Common.save') }}
    v-row(v-show="!loading")
      v-col.py-0
        v-card.elevation-24.mb-5(style="overflow: hidden")
          app-full-entity(:entity="entity", :errors="errors", v-bind="{ customLabel }")
            template(v-slot:Report="props")
              app-entity(
                :extra-data="false",
                :ignoreFields="['name','description', 'jasperPath']",
                v-bind="props"
              )
                template(v-slot:addFields)
                  v-row
                    v-col(cols="4")
                      v-text-field(
                        :label="$t('Report.name')",
                        v-model="instance.name",
                      )
                    v-col(cols="8")
                      v-text-field(
                        :label="$t('Report.businessScope')",
                        :value="businessScopePath",
                        disabled,
                      )
                    v-col(cols="12")
                      v-textarea(
                        :label="$t('Report.description')",
                        rows="1",
                        v-model="instance.description",
                      )
                    v-col(cols="7")
                      v-text-field(
                        :label="$t('Report.jasperPath')",
                        :value="instance.jasperPath",
                        disabled,
                      )
                    v-col(cols="5")
                      v-file-input(
                        small-chips,
                        :error-messages="['File is required for creation and edition']"
                        @change="setReport($event)",
                        :label="$t('Report.uploadFile')",
                      )

          div(v-if="uid != null")
            .px-5.section__title {{ $t('Report.executeTitle') }}
            v-row.px-5
              v-col(cols="3")
                v-select(
                  :label="$t('Report.selectFormat')",
                  :items="['html', 'pdf', 'docx', 'rtf', 'xlsx']"
                  v-model="format"
                )
              v-col
                v-btn(@click="getReport(format)", :disabled="loadingReport") {{ loadingReport ?  `${$t('Common.loading')}...` : $t('Report.downloadReport')  }}
                v-btn(@click="uploadReportToSharepoint(format)", :disabled="loadingReport") {{ loadingReport ? `${$t('Common.loading')}...`  : $t('Report.uploadSharepoint') }}
                //- v-btn() {{ uploadingReport ? 'Uploading...' : 'Upload to Sharepoint' }}
              v-col(cols="12", v-if="renderHTML")
                div(v-html="HTML")
          div.px-5(v-if="debug" style="overflow: scroll")
            h1 Debug
            pre {{  }}
            h2 Report Unit
            pre {{ reportUnit }}
</template>

<script>
import axios from 'axios'
import EntityMixin from '@/mixins'

export default {
  mixins: [EntityMixin],
  name: 'report-add',
  data: function () {
    return {
      debug: false,
      renderHTML: false,
      HTML: '',
      format: 'html',
      loading: true,
      loadingReport: false,
      uploadingReport: false,
      entity: this.$findEntity('Report'),
      errors: {},
      businessScopePath: localStorage.GEODIS,
      customLabel: {
        // fieldName: "customName"
      },
      reportUnit: {
        label: "",
        description: "",
        dataSource: {
            dataSourceReference: {
              uri: "/Data_Sources/EORDER_DEV_SQL"
            }
        },
        // "query" is nullable
        // query: null,
        jrxml: {
          jrxmlFile: {
            label: "Main_report",
            type: "jrxml",
            content: null
          }
        }
      }
    }
  },
  computed: {
    uid () {
      return this.$route.params.item
    },
    localStorage () {
      return localStorage
    }
  },
  methods: {
    setReport(ev) {
      console.log(this.$cleanString(ev))
      const reader = new FileReader();
      reader.onload = (e) => { this.reportUnit.jrxml.jrxmlFile.content = btoa(e.target.result) }
      reader.readAsText(ev)
    },
    async getReport(format) {
      this.loadingReport = true
      let fileName = `${this.instance.name}.${format}`
      let responseType = format === 'html' ? 'text' : 'arraybuffer'
      console.log("response type", this.$cleanString(responseType))
      axios.get(`/IOReports/execute/${this.uid}.${this.format}`, {responseType} ).then(response => {
        this.loadingReport = false
        if (format != 'html') {
          this.renderHTML = false
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
        } else if (format == 'html') {
          this.renderHTML = true
          this.HTML = response.data
        }
      }).catch(e => { this.loadingReport = false; })
    },
    async uploadReportToSharepoint (format) {
      this.renderHTML = false
      this.loadingReport = true
      axios.get(`/IOReports/uploadToSharepoint/${this.uid}.${this.format}`).then(response => {
        this.loadingReport = false;
        this.renderHTML = true
        this.HTML = `<a href="${response.data.webUrl}" target="_blank">Go to sharepoint file</a>`;
      }).catch(e => { this.loadingReport = false; })
    },
    mapReportUnitData() {
      this.reportUnit.label = this.instance.name
      this.reportUnit.description = this.instance.description
      this.instance.JasperReportUnitDescriptor = this.reportUnit
    },
    /* TODO: docs */
    async save () {
      this.mapReportUnitData()
      // return console.debug('INSTANCE', this.instance)
      try {
        this.loading = true
        if (this.instance.businessScope == null || this.instance.businessScopeId === null) this.instance.businessScopeId = this.$getBusinessScopeId()
        this.instance = (await axios.post('entity/graph', this.instance)).data
        this.$router.push({
          name: 'entities.index',
          params: {
            entity: 'Report'
          }
        })
      } catch (error) {
        //
      } finally {
        this.loading = false
      }
    },

    /* TODO: docs */
    async load () {
      if (this.uid) {
        try {
          const endpoint = this.$fetchLoad(`${this.entity.name}/${this.uid}`, true)
          let _instance = (await axios.get(endpoint, {
            _Entity: this.entity.name,
            uid: this.uid
          })).data
          _instance = {
            ..._instance,
            entityState: 3,
          };
          this.instance = _instance;
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      } else {
        this.loading = false;
        this.instance.jasperPath = `/eOrder_Reports/${localStorage.GEODIS}`
      }
    }
  },
  created() {
    this.$store.commit('SET_INSTANCE', { entityState: 4, _Entity: this.entity.name, user: this.$store.state.user.user })
  },
  async mounted () {
    await this.load()
  },
}
</script>
